import { render, staticRenderFns } from "./InspectOrderlist.vue?vue&type=template&id=9dfc7a48&scoped=true"
import script from "./InspectOrderlist.vue?vue&type=script&lang=js"
export * from "./InspectOrderlist.vue?vue&type=script&lang=js"
import style0 from "./InspectOrderlist.vue?vue&type=style&index=0&id=9dfc7a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfc7a48",
  null
  
)

export default component.exports